{
  "_comment": "[CI-LOCKED] Sadržaj ove datoteke je zaključan. Doprinosi su dobrodošli, ali potvrda promene može biti odložena.",
  "ACCESS_KEY_ALT": "Alt Shift $1",
  "ACCESS_KEY_FOR_MAC_ALT": "Control Option $1",
  "ACTIVITY_BOT_SAID_ALT": "Robot $1 je rekao:",
  "ACTIVITY_STATUS_VOICE_TRANSCRIPT_AGENT_LABEL": "Agent",
  "ACTIVITY_YOU_SAID_ALT": "Vi ste rekli:",
  "ACTIVITY_BOT_ATTACHED_ALT": "Robot je priložio:",
  "ACTIVITY_CODE_ALT": "Uzorak koda: $1",
  "ACTIVITY_CONTENT_CAUTION": "Sadržaj koji generiše veštačka inteligencija možda je netačan",
  "ACTIVITY_CODE_CAUTION": "Kod generisan pomoću veštačke inteligencije. Pregledajte i pažljivo koristite",
  "ACTIVITY_ERROR_BOX_TITLE": "Poruka o grešci",
  "ACTIVITY_INTERACTIVE_FOOTNOTE_ALT": "Kliknite za interakciju.",
  "ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT": "Poruka je interaktivna.",
  "ACTIVITY_INTERACTIVE_REASON_LINK_ALT": "Poruka sadrži jednu vez ili više njih.",
  "ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT": "Slanje nije uspelo.",
  "ACTIVITY_YOU_ATTACHED_ALT": "Priložili ste:",
  "ACTIVITY_NUM_ATTACHMENTS_ONE_ALT": "1 prilog.",
  "ACTIVITY_NUM_ATTACHMENTS_FEW_ALT": "$1 priloga.",
  "ACTIVITY_NUM_ATTACHMENTS_MANY_ALT": "$1 priloga.",
  "ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT": "$1 priloga.",
  "ACTIVITY_NUM_ATTACHMENTS_TWO_ALT": "$1 priloga.",
  "ACTIVITY_STATUS_SEND_FAILED_RETRY": "Slanje nije uspelo. [Ponovo pokušaj] [RETRY].",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING": "Slanje",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT": "Poslato u $1",
  "ACTIVITY_STATUS_TIMESTAMP_JUST_NOW": "Malopre",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO": "Pre sat vremena",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO": "Pre jednog minuta",
  "ACTIVITY_STATUS_TIMESTAMP_TODAY": "Danas",
  "ACTIVITY_STATUS_TIMESTAMP_YESTERDAY": "Juče",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE": "Greška u raščlanjivanju prilagodljive kartice",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER": "Greška u prikazivanju prilagodljive kartice",
  "ATTACHMENT_AUDIO": "Audio klip.",
  "ATTACHMENT_CARD": "Kartica: $1 $2 $3",
  "ATTACHMENT_FILE": "Datoteka: $1",
  "ATTACHMENT_IMAGE": "Slika",
  "ATTACHMENT_TEXT": "Tekst: $1",
  "ATTACHMENT_VIDEO": "Video klip",
  "AVATAR_ALT": "$1 – avatar",
  "CAROUSEL_FLIPPER_NEXT_ALT": "Dalje",
  "CAROUSEL_FLIPPER_PREVIOUS_ALT": "Prethodno",
  "CITATION_MODEL_DIALOG_ALT": "Citat",
  "CLOSE_BUTTON_ALT": "Zatvori",
  "COLLAPSIBLE_GROUPING_TITLE": "Razmišljanje je u toku…",
  "COLLAPSIBLE_GROUPING_TITLE.comment": "Ovo se prikazuje kada bot sastavlja poruke odgovora u grupi ako nije naveden sažetak.",
  "COLLAPSE_BUTTON_LESS": "Prikaži manje",
  "COLLAPSE_BUTTON_LESS.comment": "Ovo je tekst dugmeta „ševron“ za skupljanje grupe poruka. Kada krajnji korisnik klikne na dugme, grupa poruka se savije.",
  "COLLAPSE_BUTTON_MORE": "Prikaži više",
  "COLLAPSE_BUTTON_MORE.comment": "Ovo je tekst dugmeta „ševron“ za proširenje grupe poruka. Kada krajnji korisnik klikne na dugme, grupa poruka se širi.",
  "CONNECTIVITY_STATUS_ALT_CONNECTED": "Povezano",
  "CONNECTIVITY_STATUS_ALT_CONNECTING": "Povezivanje…",
  "CONNECTIVITY_STATUS_ALT_FATAL": "Povezivanje nije moguće.",
  "CONNECTIVITY_STATUS_ALT_RECONNECTING": "Došlo je do prekida mreže. Ponovno povezivanje…",
  "CONNECTIVITY_STATUS_ALT_RENDER_ERROR": "Greška u prikazivanju. Proverite konzolu ili se obratite programeru robota.",
  "CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION": "Povezivanje traje duže nego inače.",
  "CONNECTIVITY_STATUS_ALT": "Status povezivanja: $1",
  "COPY_BUTTON_TEXT": "Kopiraj",
  "COPY_BUTTON_COPIED_TEXT": "Kopirano",
  "FEEDBACK_FORM_SUBMIT_BUTTON_LABEL": "Prosledi",
  "FEEDBACK_FORM_CANCEL_BUTTON_LABEL": "Otkaži",
  "FEEDBACK_FORM_PLACEHOLDER": "Dajte što više detalja, ali nemojte uključivati privatne ili osetljive informacije.",
  "FEEDBACK_FORM_TITLE": "Recite nam o svom iskustvu",
  "FILE_CONTENT_ALT": "„$1“",
  "FILE_CONTENT_DOWNLOADABLE_ALT": "Preuzimanje datoteke „$1“",
  "FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT": "Preuzmite datoteku „$1“ veličine $2",
  "FILE_CONTENT_WITH_SIZE_ALT": "„$1“ veličine $2",
  "MARKDOWN_EXTERNAL_LINK_ALT": "Otvara se u novom prozoru; spoljno.",
  "RECEIPT_CARD_TAX": "Porez",
  "RECEIPT_CARD_TOTAL": "Ukupno",
  "RECEIPT_CARD_VAT": "PDV",
  "REFERENCE_LIST_HEADER_ONE": "$1 referenca",
  "REFERENCE_LIST_HEADER_FEW": "$1 referenci",
  "REFERENCE_LIST_HEADER_MANY": "$1 referenci",
  "REFERENCE_LIST_HEADER_OTHER": "$1 referenci",
  "REFERENCE_LIST_HEADER_TWO": "$1 reference",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_ALT": "Izbriši prilog $1",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_TOOLTIP": "Izbriši",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_FILE_ALT": "Datoteka",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_IMAGE_ALT": "Slika",
  "SEND_BOX_IS_EMPTY_TOOLTIP_ALT": "Nije moguće poslati praznu poruku.",
  "SPEECH_INPUT_LISTENING": "Slušamo…",
  "SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT": "Mikrofon je isključen",
  "SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT": "Mikrofon je uključen",
  "SPEECH_INPUT_STARTING": "Počinje…",
  "SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT": "Dalje",
  "SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT": "Prethodno",
  "SUGGESTED_ACTIONS_LABEL_ALT": "Predložene radnje",
  "TEXT_INPUT_ALT": "Polje za unos poruke",
  "TEXT_INPUT_PLACEHOLDER": "Otkucajte poruku",
  "TEXT_INPUT_SPEECH_IDLE_PLACEHOLDER": "Počnite da govorite…",
  "TEXT_INPUT_SPEECH_LISTENING_PLACEHOLDER": "Slušanje…",
  "TEXT_INPUT_SPEECH_PROCESSING_PLACEHOLDER": "Obrada…",
  "TEXT_INPUT_SPEECH_BOT_SPEAKING_PLACEHOLDER": "Govorite da biste ga prekinuli…",
  "TEXT_INPUT_SEND_BUTTON_ALT": "Pošalji",
  "TEXT_INPUT_SPEAK_BUTTON_ALT": "Izgovorite",
  "TEXT_INPUT_UPLOAD_BUTTON_ALT": "Otpremi datoteku",
  "TEXT_INPUT_TELEPHONE_KEYPAD_BUTTON_ALT": "Telefonska tastatura",
  "TEXT_INPUT_DROP_ZONE": "Otpustite datoteke",
  "TEXT_INPUT_LENGTH_EXCEEDED_ALT": "Prekoračena je dužina poruke",
  "TELEPHONE_KEYPAD_INPUT_MESSAGE": "Podržava samo jednocifreni unos",
  "TEXT_INPUT_ATTACHMENTS_FEW": "$1 priloga",
  "TEXT_INPUT_ATTACHMENTS_MANY": "$1 priloga",
  "TEXT_INPUT_ATTACHMENTS_ONE": "1 prilog",
  "TEXT_INPUT_ATTACHMENTS_OTHER": "$1 priloga",
  "TEXT_INPUT_ATTACHMENTS_TWO": "$1 priloga",
  "TOAST_ACCORDION_FEW": "$1 obaveštenja: Kliknite ovde da biste videli detalje",
  "TOAST_ACCORDION_MANY": "$1 obaveštenja: Kliknite ovde da biste videli detalje",
  "TOAST_ACCORDION_OTHER": "$1 obaveštenja: Kliknite ovde da biste videli detalje",
  "TOAST_ACCORDION_TWO": "$1 obaveštenja: Kliknite ovde da biste videli detalje",
  "TOAST_ALT_ERROR": "Greška",
  "TOAST_ALT_INFO": "Informacije",
  "TOAST_ALT_SUCCESS": "Uspešno",
  "TOAST_ALT_WARN": "Upozorenje",
  "TOAST_DISMISS_BUTTON": "Odbaci",
  "TOAST_TITLE_ALT": "Obaveštenje",
  "TRANSCRIPT_ARIA_LABEL_ALT": "Istorija ćaskanja, koristite tastere sa strelicom da biste se kretali.",
  "TRANSCRIPT_ARIA_ROLE_ALT": "istorija ćaskanja",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT": "Poruka je interaktivna. Pritisnite tastere Shift i Tab 2 do 3 puta da biste se prebacili na istoriju ćaskanja. Zatim kliknite na poruku da biste ostvarili interakciju.",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT": "Poruka sadrži veze. Pritisnite tastere Shift i Tab 2 do 3 puta da biste se prebacili na istoriju ćaskanja. Zatim kliknite na poruku da biste ostvarili interakciju.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT": "Poruka ima predložene radnje. Pritisnite tastere shift tab 2 do 3 puta kako biste ih izabrali.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT": "Poruka ima predložene radnje. Pritisnite $1 kako biste ih izabrali.",
  "TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT": "Slanje poruke nije uspelo.",
  "TRANSCRIPT_LIVE_REGION_NEW_MESSAGES_ALT": "Dostupne su nove poruke. Pritisnite $1 da biste se fokusirali na dugme „$2“.",
  "TRANSCRIPT_MORE_MESSAGES": "Još poruka",
  "TRANSCRIPT_NEW_MESSAGES": "Nove poruke",
  "TRANSCRIPT_TERMINATOR_TEXT": "Kraj istorije ćaskanja",
  "TYPING_INDICATOR_ALT": "Prikazuje se indikator kucanja",
  "TYPING_INDICATOR_SINGLE_TEXT": "$1 kuca.",
  "TYPING_INDICATOR_MULTIPLE_TEXT": "$1 i drugi kucaju.",
  "VIEW_CODE_BUTTON_TEXT": "Kôd",
  "VOTE_COMPLETE_ALT": "Povratne informacije su snimljene",
  "VOTE_COMPLETE_ALT.comment": "Ovo je za čitač ekrana. Oznaka dugmeta sa ikonama palca nagore/nadole. Oznaka se koristi kada je snimljena povratna informacija.",
  "VOTE_DISLIKE_ALT": "Ne sviđa mi se",
  "VOTE_LIKE_ALT": "Sviđa mi se"
}